import DOMPurify from 'dompurify'

/**
 * 2022.05.13 FE최재하
 * @params html : sanitize를 적용시킬 문자열 html
 */
export const sanitize = (html: string): string => {
  return DOMPurify.sanitize(html)
}
